import React from 'react';

import RadioGroup from '@magoosh/lib/formik_inputs/field_radio_group';
import { formatPrice } from 'utilities/money';

import { PaymentStyle, Pricing, SubscriptionPlan } from '@payments/legacy_payments/types';
import * as utils from '@payments/legacy_payments/utils';

interface Props {
  onChange: (paymentStyle: string) => void;
  paymentStyle: PaymentStyle;
  subscriptionPlan: SubscriptionPlan;
  totalExcludingTax: number;
}

export const InstallmentsFormGroup: React.FC<Props> = ({
  onChange,
  paymentStyle,
  subscriptionPlan,
  totalExcludingTax
}) => {
  const formattedInstallmentsDates = utils.calculateInstallmentsDates(
    subscriptionPlan.installmentInterval,
    subscriptionPlan.installmentIntervalCount
  );

  return (
    <div className="form-group">
      <fieldset className="inputs">
        <legend className="u-margin-B-n">
          <span>Payment</span>
        </legend>
        <div className="d-flex justify-content-between">
          <RadioGroup
            name="installmentTypeId"
            optionsArray={[
              {
                label: `Pay full ${formatPrice(totalExcludingTax)} today`,
                value: PaymentStyle.FULLPAYMENT
              },
              {
                label: 'Pay in installments',
                value: PaymentStyle.INSTALLMENTS,
                children: (
                  <div>
                    <small>
                      <p>Four interest-free payments. No fees or credit check.</p>
                      <ul className="list-unstyled u-padding-L-xs" style={{borderLeft: 'solid 5px #e5e5e5'}}>
                        {formattedInstallmentsDates.map((date, index) => (
                          <li key={index}>
                            Due <strong>{date}</strong> {formatPrice(utils.calculateInstallmentsPrice(totalExcludingTax))}
                          </li>
                        ))}
                      </ul>
                    </small>
                  </div>
                )
              }
            ]}
            value={paymentStyle}
            onChangeCondition={onChange}
          />
        </div>
      </fieldset>
    </div>
  );
};

export default InstallmentsFormGroup;
